import { ActionTree } from 'vuex'
import { WorkFileState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<WorkFileState, RootState> = {
}
